module.exports = __webpack_public_path__ + "img/Ute_Front.72646bc9.svg";